import { EventsService } from 'api-clients/monolith';
import { useCallback } from 'react';

import { useApiService } from 'hooks/useApiService';

export const useStageOnSiteAddresses = ({
  user,
  stageTitles,
  openingTitles,
  locationGroupTitles,
  openingOwnerTitles,
}: {
  user?: string;
  stageTitles: Array<string>;
  openingTitles?: Array<string>;
  locationGroupTitles?: Array<string>;
  openingOwnerTitles?: Array<string>;
}) => {
  const locationService = useCallback(
    () =>
      EventsService.getInternalApiEventsConditions(
        stageTitles,
        openingTitles,
        locationGroupTitles,
        user,
        openingOwnerTitles,
      ),
    [locationGroupTitles, openingTitles, stageTitles, user, openingOwnerTitles],
  );
  const { result } = useApiService(locationService);
  return { result };
};
